import React, { FC } from 'react';
import SVGUniqueID from 'react-svg-unique-id';

interface SearchIconProps {
  width?: number;
  height?: number;
  className?: string;
}

const SearchIcon: FC<SearchIconProps> = ({
  width = 14,
  height = 14,
  className
}) => {
  return (
    <SVGUniqueID>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={width}
        height={height}
        viewBox="0 0 14 14"
        fill="none"
        className={className}
      >
        <path
          d="M12.75 12.75L9.85 9.85M11.4167 6.08333C11.4167 9.02885 9.02885 11.4167 6.08333 11.4167C3.13781 11.4167 0.75 9.02885 0.75 6.08333C0.75 3.13781 3.13781 0.75 6.08333 0.75C9.02885 0.75 11.4167 3.13781 11.4167 6.08333Z"
          stroke="#475569"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </SVGUniqueID>
  );
};

export { SearchIcon };
